var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sticky-top"},[_c('message-navigation')],1),_c('message-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }